import LogoPine from "@/assets/svg/logo-pine.svg";
import LogoWhite from "@/assets/svg/logo-white.svg";

export interface ColocaLogoProps {
  variant?: "white" | "black";
  className?: string;
}

export const ColocaLogo: React.FC<ColocaLogoProps> = ({ variant = "black", className }) => {
  return (
    <div className={className}>
      <img src={variant === "white" ? LogoWhite : LogoPine} alt="Coloca" />
    </div>
  );
};
